module.exports = __webpack_public_path__ + "static/img/amd9.ac3f4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd9.png
// module id = LMZr
// module chunks = 1